import React from "react";
import PublicMapContent from "./PublicMapContent";

const PublicMapIFrame = () => <PublicMapContent variant="iframe" />;

export default PublicMapIFrame;
